/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Form, Formik } from "formik";
import { Alert, Box, Button, Icon, Typography } from "@mui/material";
import FileInput from "src/components/input/FileInput";
import {
  setValoresInicialesUsuarioUnidad,
  IdocumentosForm,
  esquemaDeValidacionDocumentos,
} from "./utils";
import MarkAllFieldsTouched from "src/components/input/MarkAsTouched";

export interface AsociarPersonaAunidadProps {
  setDocumentos: (values: any) => void;
  handleNext: () => void;
  handleBack: () => void;
  handleSend: (documentosForm: any) => void;
  documentos: IdocumentosForm;
  onSubmit: (values: IdocumentosForm) => void;
  aspiranteId: string;
}

const DocumentosRequeridosForm = ({
  handleNext,
  handleBack,
  handleSend,
  setDocumentos,
  documentos,
  onSubmit,
  aspiranteId,
}: AsociarPersonaAunidadProps) => {
  const [valoresForm, setValoresForm] = useState(
    setValoresInicialesUsuarioUnidad(documentos),
  );
  const [fileDocumentoIdentidadAdjuntoId, setFileDocumentoIdentidadAdjuntoId] =
    useState<File | null>(null);
  const [fileTarjetaProfesionalAdjuntoId, setFileTarjetaProfesionalAdjuntoId] =
    useState<File | null>(null);
  const [fileAntecedentesProfesionalAdjuntoId, setFileAntecedentesProfesionalAdjuntoId] =
    useState<File | null>(null);
  const [
    fileCertificadoContraloriaAdjuntoId,
    setFileCertificadoContraloriaAdjuntoId,
  ] = useState<File | null>(null);
  const [
    fileCertificadoProcuraduriaAdjuntoId,
    setFileCertificadoProcuraduriaAdjuntoId,
  ] = useState<File | null>(null);
  const [
    fileCertificadoPoliciaNacionalAdjuntoId,
    setFileCertificadoPoliciaNacionalAdjuntoId,
  ] = useState<File | null>(null);
  const [fileCertificadoRnmcAdjuntoId, setFileCertificadoRnmcAdjuntoId] =
    useState<File | null>(null);
  const [fileHojaDeVidaAdjuntoId, setFileHojaDeVidaAdjuntoId] =
    useState<File | null>(null);
  const [departamentoSeleccionado, setDepartamentoSeleccionado] =
    useState<string>("");

  return (
    <Box sx={{ display: "flex", flexDirection: "column",justifyContent: "center", alignItems: 'center',width: "100%" }}>
      <Alert severity="warning" sx={{ width: "80%", textAlign: "left" }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
          Si su profesión requiere tarjeta profesional y/o certificado de antecedentes profesionales, 
          por favor adjunte los documentos correspondientes.
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: "medium" }}>
          <b>Nota:</b> Si no adjunta los documentos requeridos para su profesión, el equipo de selección deberá
          validar manualmente la información, lo que podría generar reprocesos y demoras en su solicitud.
        </Typography>
     </Alert>
      <br />
      <Formik
        enableReinitialize
        initialValues={valoresForm}
        validationSchema={esquemaDeValidacionDocumentos}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, validateForm, setTouched, isValid , submitForm}) => (
          <Form
            autoComplete="off"
            id="form-nuevo-usuario"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                width: "80%",
                display: "flex",
                gap: 1,
                flexDirection: "column",
              }}
            >
              <MarkAllFieldsTouched values={valoresForm} />
              <FileInput
                id="hojaDeVidaAdjuntoId"
                setValue={(value: any) => {
                  setFieldValue("hojaDeVidaAdjuntoId", value);
                }}
                value={values.hojaDeVidaAdjuntoId}
                selectedFile={fileHojaDeVidaAdjuntoId}
                setSelectedFile={setFileHojaDeVidaAdjuntoId}
                label="Hoja de vida"
                proyectoId=""
                aspiranteId={aspiranteId}
              />
              <FileInput
                id="documentoIdentidadAdjuntoId"
                setValue={(value: any) => {
                  setFieldValue("documentoIdentidadAdjuntoId", value);
                }}
                value={values.documentoIdentidadAdjuntoId}
                selectedFile={fileDocumentoIdentidadAdjuntoId}
                setSelectedFile={setFileDocumentoIdentidadAdjuntoId}
                label="Documento de identidad"
                proyectoId=""
                aspiranteId={aspiranteId}
              />
              <FileInput
                id="tarjetaProfesionalAdjuntoId"
                setValue={(value: any) => {
                  setFieldValue("tarjetaProfesionalAdjuntoId", value);
                }}
                value={values.tarjetaProfesionalAdjuntoId}
                selectedFile={fileTarjetaProfesionalAdjuntoId}
                setSelectedFile={setFileTarjetaProfesionalAdjuntoId}
                label="Tarjeta profesional"
                proyectoId=""
                aspiranteId={aspiranteId}
              />
              <FileInput
                id="certificadoAntecedentesDisciplinariosId"
                setValue={(value: any) => {
                  setFieldValue("certificadoAntecedentesDisciplinariosId", value);
                }}
                value={values.certificadoAntecedentesDisciplinariosId}
                selectedFile={fileAntecedentesProfesionalAdjuntoId}
                setSelectedFile={setFileAntecedentesProfesionalAdjuntoId}
                label="Certificado antecedentes profesionales"
                nameFecha="certificadoAntecedentesDisciplinariosFecha"
                proyectoId=""
                aspiranteId={aspiranteId}
              />
              <FileInput
                id="certificadoContraloriaAdjuntoId"
                setValue={(value: any) => {
                  setFieldValue("certificadoContraloriaAdjuntoId", value);
                }}
                value={values.certificadoContraloriaAdjuntoId}
                selectedFile={fileCertificadoContraloriaAdjuntoId}
                setSelectedFile={setFileCertificadoContraloriaAdjuntoId}
                label="Certificado contraloria"
                nameFecha="certificadoContraloriaAdjuntoFecha"
                proyectoId=""
                aspiranteId={aspiranteId}
                indications="Adjunte un certificado vigente, emitido en los últimos 30 días."
                info="Descárguelo de https://www.contraloria.gov.co/web/guest/persona-juridica"
              />
              <FileInput
                id="certificadoProcuraduriaAdjuntoId"
                setValue={(value: any) => {
                  setFieldValue("certificadoProcuraduriaAdjuntoId", value);
                }}
                value={values.certificadoProcuraduriaAdjuntoId}
                selectedFile={fileCertificadoProcuraduriaAdjuntoId}
                setSelectedFile={setFileCertificadoProcuraduriaAdjuntoId}
                label="Certificado procuraduria"
                nameFecha="certificadoProcuraduriaAdjuntoFecha"
                proyectoId=""
                aspiranteId={aspiranteId}
                indications="Adjunte un certificado vigente, emitido en los últimos 30 días."
                info="Descárguelo de https://www.procuraduria.gov.co/Pages/Generacion-de-antecedentes.aspx"
              />
              <FileInput
                id="certificadoPoliciaNacionalAdjuntoId"
                setValue={(value: any) => {
                  setFieldValue("certificadoPoliciaNacionalAdjuntoId", value);
                }}
                value={values.certificadoPoliciaNacionalAdjuntoId}
                selectedFile={fileCertificadoPoliciaNacionalAdjuntoId}
                setSelectedFile={setFileCertificadoPoliciaNacionalAdjuntoId}
                label="Certificado policía nacional"
                nameFecha="certificadoPoliciaNacionalAdjuntoFecha"
                proyectoId=""
                aspiranteId={aspiranteId}
                indications="Adjunte un certificado vigente, emitido en los últimos 30 días."
                info="Descárguelo de https://antecedentes.policia.gov.co:7005/WebJudicial/"
              />
              <FileInput
                id="certificadoRnmcAdjuntoId"
                setValue={(value: any) => {
                  setFieldValue("certificadoRnmcAdjuntoId", value);
                }}
                value={values.certificadoRnmcAdjuntoId}
                selectedFile={fileCertificadoRnmcAdjuntoId}
                setSelectedFile={setFileCertificadoRnmcAdjuntoId}
                label="Certificado del registro nacional de medidas correctivas"
                nameFecha="certificadoRnmcAdjuntoFecha"
                proyectoId=""
                aspiranteId={aspiranteId}
                indications="Adjunte un certificado vigente, emitido en los últimos 30 días."
                info="Descárguelo de https://srvcnpc.policia.gov.co/PSC/frm_cnp_consulta.aspx"
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mt: 2,
                width: "100%",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setDocumentos(values)
                  handleBack();
                }}
                startIcon={<Icon>chevron_left</Icon>}
              >
                Atrás
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  validateForm();
                  submitForm();
                  if (isValid) {
                    setDocumentos(values);
                    handleNext();
                    handleSend(values);
                    validateForm();
                  }
                }}
              >
                Enviar
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default DocumentosRequeridosForm;
